const easeInExpo = [0.7, 0, 0.84, 0];
const easeOutExpo = [0.16, 1, 0.3, 1];
const easeInOutExpo = [0.87, 0, 0.13, 1];
const DRAG_ELASTIC = 0.3;
const DRAG_TRANSITION = {bounceStiffness: 1000, bounceDamping: 50};
const DRAG_CONSTRAINTS = {left: 0, right: 0};
const OFFSET_BOUNDARY = 10;

const getCardVariants = ({
    direction,
    touched
}: {
    direction: string;
    touched: boolean;
}) => ({
    first: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: {duration: 1, ease: easeOutExpo}
    },
    second: {
        opacity: 1,
        y: 32,
        scale: 0.9,
        transition: {duration: 1, ease: easeOutExpo, delay: 0}
    },
    third: {
        opacity: 1,
        y: 64,
        scale: 0.8,
        transition: {duration: 1, ease: easeOutExpo, delay: 0}
    },
    remainings: {
        opacity: 0,
        y: 24
    },
    exit: {
        opacity: 0,
        x: direction === 'left' ? -600 : 600,
        rotate: direction === 'left' ? -15 : 15,
        transition: {duration: touched ? 1 : 2, ease: easeOutExpo}
    }
});

const getCards = (cards: any[]) => {
    cards = [...cards].reverse();
    function indexMapper(bannerItem: any, index: number) {
        return {
            ...bannerItem,
            orgIndex: index
        };
    }

    function idMapper(bannerItem: any, index: number) {
        return {
            ...bannerItem,
            id: index + 1
        };
    }

    if (cards?.length === 1) {
        return [...cards?.map(indexMapper)].map(idMapper);
    }

    if (cards?.length < 5) {
        return [
            ...cards?.map(indexMapper),
            ...cards?.map(indexMapper),
            ...cards?.map(indexMapper)
        ].map(idMapper);
    } else {
        return cards?.map(indexMapper)?.map(idMapper);
    }
};

export {
    DRAG_ELASTIC,
    DRAG_TRANSITION,
    DRAG_CONSTRAINTS,
    OFFSET_BOUNDARY,
    getCardVariants,
    getCards,
    easeInExpo,
    easeOutExpo,
    easeInOutExpo
};
